import React from "react";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  Divider,
} from "@mui/material";
import { IoClose } from "react-icons/io5";

export default function UserAccount({ open, onClose, currentUser, setToggleAccount }) {
  const handleClose = () => {
    if (onClose) onClose();
    if (setToggleAccount) setToggleAccount(false);
  };

  if (!currentUser) return null;

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>
        Account Details
        <IconButton
          onClick={handleClose}
          sx={{ position: "absolute", top: 8, right: 8 }}
          size="small"
        >
          <IoClose size={24} />
        </IconButton>
      </DialogTitle>
      <Divider />
      <DialogContent>
        <Box>
          <Typography variant="body1" sx={{ mb: 1 }}>
            <strong>Name:</strong> {currentUser.Name}
          </Typography>
          <Typography variant="body1" sx={{ mb: 1 }}>
            <strong>Email:</strong> {currentUser.Email ?? "—"}
          </Typography>
          <Typography variant="body1" sx={{ mb: 1 }}>
            <strong>Department:</strong> {currentUser.Department ?? "—"}
          </Typography>
          <Typography variant="body1" sx={{ mb: 1 }}>
            <strong>Role:</strong> {currentUser.Role ?? "—"}
          </Typography>
          <Typography variant="body1" sx={{ mb: 1 }}>
            <strong>Phone:</strong> {currentUser.Phone ?? "—"}
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
